import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header'
import SplitTestActions from 'modules/funnels/funnel/components/split-tests-tab/split-test-actions'
import SplitTestHistory from 'modules/funnels/funnel/components/split-tests-tab/split-test-history'
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum'
import { useFunnelStepTests } from 'modules/funnels/funnel/hooks/use-funnel-step-tests'
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import React from 'react'
import { Loader } from 'shared/components/loader'

interface SplitTestsTabProps {
  funnelId: FunnelId
  funnelStep: FunnelStepInterface | null
}

function SplitTestsTab({ funnelId, funnelStep }: SplitTestsTabProps) {
  const { splitTestData } = useFunnelStepTests(funnelStep?.id)

  if (!splitTestData || !funnelStep)
    return <Loader className={'mb-10 mt-10 flex scale-150 justify-center'} />

  return (
    <div className="mb-10 flex flex-col gap-8 px-4 lg:px-0">
      <MobileSettingsHeader type={FunnelStepSettingTabsEnum.tests} />
      <SplitTestActions funnelId={funnelId} funnelStep={funnelStep} data={splitTestData} />
      <SplitTestHistory funnelStep={funnelStep} />
    </div>
  )
}

export default SplitTestsTab
